import { Link } from 'react-router-dom';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

export default function Footer() {
  const { resolvedTheme, toggleTheme } = useTheme();

  return (
    <footer 
      className="border-t border-border bg-surface"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Column */}
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="font-serif-display text-2xl font-medium tracking-tight">
                JobMatch<span className="italic">Pro</span>
              </span>
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-sm">
              AI-powered job matching that saves you time and connects you with opportunities tailored to your unique profile.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-medium mb-4 text-sm uppercase tracking-wider">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/" 
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  data-testid="footer-home-link"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link 
                  to="/#features" 
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  data-testid="footer-features-link"
                >
                  Features
                </Link>
              </li>
              <li>
                <Link 
                  to="/find-jobs" 
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  data-testid="footer-find-jobs-link"
                >
                  Find Jobs
                </Link>
              </li>
            </ul>
          </div>

          {/* Theme Toggle */}
          <div>
            <h4 className="font-medium mb-4 text-sm uppercase tracking-wider">Appearance</h4>
            <button
              onClick={toggleTheme}
              className="theme-toggle flex items-center gap-3"
              data-testid="theme-toggle-btn"
              aria-label={`Switch to ${resolvedTheme === 'dark' ? 'light' : 'dark'} mode`}
            >
              {resolvedTheme === 'dark' ? (
                <>
                  <Sun className="w-4 h-4" />
                  <span className="text-sm">Light Mode</span>
                </>
              ) : (
                <>
                  <Moon className="w-4 h-4" />
                  <span className="text-sm">Dark Mode</span>
                </>
              )}
            </button>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} JobMatch Pro. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link 
              to="/privacy-policy" 
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
              data-testid="footer-privacy-link"
            >
              Privacy Policy
            </Link>
            <Link 
              to="/manage-data" 
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
              data-testid="footer-manage-data-link"
            >
              Manage Your Data
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
